import { useState } from "react";
import { useNavigate } from "react-router-dom";

// images
import { GrFormClose } from "react-icons/gr";

function ComingSoonPage() {
    const navigate = useNavigate();

    const [input, setInput] = useState("");
    const [openDialog, setOpenDialog] = useState(false);

    const handleNotifyEmail = () => {
        if(!input) {
            alert("Please enter your Email adress.")
            return;
        }
        setOpenDialog(true);
    }

    const handleCloseDialog = () => {
        setInput("")
        setOpenDialog(false);
    }

    return (
        <div className="ComingSoonPage">
            <div className="ComingSoonPage-Content">
                <div className="Title">We're coming soon</div>
                <div className="Text">
                    <div>
                        We're working hard to give you the best experience.
                    </div>
                    <div>
                        Hit the button for next product notification!
                    </div>
                    <div>
                        Only great content, we don't share your email with other.
                    </div>
                </div>
                <div className="Input">
                    <input type="email" onChange={(e)=>setInput(e.target.value)} value={input} placeholder="Enter your email adress"/>
                    <button onClick={handleNotifyEmail}>NOTIFY ME</button>
                </div>
            </div>
            <button
                className="BackButton"
                onClick={()=>navigate("/")}
            >Back to overview</button>

            {openDialog &&
                <div className="Dialog">
                    <div className="Dialog-Content">
                        <button
                            className="Dialog-Close"
                            onClick={handleCloseDialog}
                        >
                            <GrFormClose />
                        </button>
                        <div className="Dialog-Text">
                            <div>Successfully entered!</div>
                            <div>We will send you an email to</div>
                            <div><span>{input}</span> later.</div>
                        </div>
                        <button
                            className="Dialog-Submit"
                            onClick={handleCloseDialog}
                        >
                            Got it
                        </button>
                    </div>
                </div>
            }
        </div>
    );
}

export default ComingSoonPage;